import { useForm } from 'react-hook-form';
import './ProfileForm.css';

const ProfileForm = ({ user, onSubmit, loading }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      fullName: user?.full_name || '',
      phoneNumber: user?.phone_number || '',
      address: user?.address || '',
      city: user?.city || '',
    },
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="profile-form">
      <div className="form-group">
        <label htmlFor="email">Email</label>
        <input id="email" type="email" value={user?.email || ''} disabled />
        <small>Email cannot be changed</small>
      </div>

      <div className="form-group">
        <label htmlFor="fullName">Full Name</label>
        <input
          id="fullName"
          type="text"
          {...register('fullName', { required: 'Full name is required' })}
        />
        {errors.fullName && (
          <span className="error">{errors.fullName.message}</span>
        )}
      </div>

      <div className="form-group">
        <label htmlFor="phoneNumber">Phone Number</label>
        <input
          id="phoneNumber"
          type="tel"
          {...register('phoneNumber', {
            pattern: {
              value: /^[0-9]{10}$/,
              message: 'Phone number must be 10 digits',
            },
          })}
        />
        {errors.phoneNumber && (
          <span className="error">{errors.phoneNumber.message}</span>
        )}
      </div>

      <div className="form-group">
        <label htmlFor="address">Address</label>
        <textarea id="address" rows="3" {...register('address')} />
        {errors.address && (
          <span className="error">{errors.address.message}</span>
        )}
      </div>

      <div className="form-group">
        <label htmlFor="city">City</label>
        <input id="city" type="text" {...register('city')} />
        {errors.city && <span className="error">{errors.city.message}</span>}
      </div>

      <button type="submit" className="btn-primary" disabled={loading}>
        {loading ? 'Saving...' : 'Save Changes'}
      </button>
    </form>
  );
};

export default ProfileForm;
